var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-input',_vm._g(_vm._b({attrs:{"inputType":"textarea"},on:{"change":val => _vm.$emit('change', val)}},'core-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }